export { default } from "./tooltip-warning";
